import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay } from "swiper";
import * as styles from "./carouselPic.module.scss";
import "swiper/swiper.scss";

interface Props {
  setSwiper: any;
  swiperContainerClass?: string;
}

SwiperCore.use([Autoplay]);

export const CarouselPic: React.FC<Props> = ({
  setSwiper,
  swiperContainerClass,
}) => {
  return (
    <div className={styles.wrapper}>
      <Swiper
        slidesPerView={1}
        autoplay={true}
        direction="horizontal"
        loop={true}
        // loopFillGroupWithBlank={true}
        onSwiper={(swiper) => setSwiper(swiper)}
        // onSlideChange={() => console.log("change")}
        // centeredSlides={true}
        className={swiperContainerClass || styles.swiperContainer}
      >
        <SwiperSlide>
          <div className={styles.cardPic}>
            <StaticImage
              src={
                "../../../static/images/Quinta-Da-Marinha-Golf-vue-aerienne-du-parcours-de-golf-Drone-.jpg"
              }
              alt={"card"}
            />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className={styles.cardPic}>
            <StaticImage src={"../../../static/images/004.jpg"} alt={"card"} />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className={styles.cardPic}>
            <StaticImage
              src={"../../../static/images/50593221611_fc6f708132_o.jpg"}
              alt={"card"}
            />
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className={styles.cardPic}>
            <StaticImage
              src={"../../../static/images/51066064702_9be38ff0f5_o.jpg"}
              alt={"card"}
            />
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};
